import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';

const OrderRegister = ({onAddItem}) => {
  const { reservationInvoiceDetails } = useSelector(state => ({
    reservationInvoiceDetails: state.reservationsReducer.reservationInvoiceDetails
  }))
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  }

  useEffect(() => {
    if(reservationInvoiceDetails.menuInfo) {
      setActiveTab(reservationInvoiceDetails.menuInfo[0].menuCategoryId);
    }
  }, [reservationInvoiceDetails.menuInfo])


  return (
    <>
      {reservationInvoiceDetails.menuInfo && <div className="my-2  orderRegister">
        <div className='col-12 px-3 py-1 font-weight-bold text-dark'>
          {locales('titles.reserve.order')}
        </div>
      
            <Nav tabs>
              {reservationInvoiceDetails.menuInfo.map(item => {
                return <NavItem key={item.menuCategoryId}>
                  <NavLink
                    className={`${activeTab === item.menuCategoryId ? 'active' : ''}`}
                    onClick={() => toggle(item.menuCategoryId)}
                  >
                    {item.menuCategoryTitle}
                  </NavLink>
                </NavItem>
              })}
            </Nav>
         
            <TabContent activeTab={activeTab} className="mt-2">
            {reservationInvoiceDetails.menuInfo.map(item => { 
              return  <TabPane key={item.menuCategoryId} tabId={item.menuCategoryId}>
             <Row>
               {item.menuItems.map(sub => {
                 return <button className="btn btn-success btn-sm m-2" onClick={() => onAddItem(sub ,item)}>
                   <i class="fa fa-plus mt-1" aria-hidden="true"></i>

                     {sub.menuItemTitle}
                   </button>
               })}
         
            </Row>
            </TabPane>
            })}
            </TabContent>
      </div>
      }
    </>

  );
}


export default OrderRegister;